class EventLandingViewItem extends HTMLElement {
  #observer;

  connectedCallback() {
    const target = this.#getObserveTarget();
    if (!target) return;

    this.#observer = new IntersectionObserver(
      (entries, observer) => {
        const entry = entries[0];
        if (!entry?.isIntersecting) return;

        observer.unobserve(target);
        this.#pushEvent();
      },
      { threshold: 0.25 },
    );

    this.#observer.observe(target);
  }

  #getObserveTarget() {
    return this.closest('.shopify-section');
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  #pushEvent() {
    const ecommerce = this.#getEcommerceData();
    if (!ecommerce) return;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'landing_view_item',
      ecommerce,
    });
  }

  #getEcommerceData() {
    if (!this.dataset.ecommerce) return null;

    try {
      return JSON.parse(this.dataset.ecommerce);
    } catch {
      return null;
    }
  }
}

if (!customElements.get('event-landing-view-item')) {
  customElements.define('event-landing-view-item', EventLandingViewItem);
}
